import React from 'react';
import { PartyType } from '../../../../../../../../types/SMT';
import InsurancePolicyPackagesContainer from '../../../../../../../advisory-report/src/features/creation-flow/components/insurance-policies/current-insurances/packages/InsurancePolicyPackagesContainer';
import {
  InsurancePolicy,
  InsurancePolicyPackage,
} from '../../../../../../../advisory-report/src/types/AdvisoryReport';
import { Option } from '../../../../../../../design-system/src/content/components/SearchPickerList/SearchPickerList';
import { useRemoveInsurancePolicyPackage } from '../../../api/insurance-policies/deleteInsurancePolicyPackageForParty';
import { useUpdateInsurancePolicyPackage } from '../../../api/insurance-policies/putInsurancePolicyPackageForParty';

interface Props {
  partyId: string;
  packages: InsurancePolicyPackage[];
  partyType: PartyType;
  customRiskObjects?: Option[];

  // Actions
  onEditPolicy: (insurancePolicy: InsurancePolicy) => void;
  onRemovePolicy: (id: string, packageId?: string) => void;
}

const PartyInsurancePolicyPackagesContainer: React.FC<Props> = ({
  partyId,
  partyType,
  packages,
  customRiskObjects,
  onEditPolicy,
  onRemovePolicy,
}) => {
  const { mutate: updateInsurancePackage } = useUpdateInsurancePolicyPackage();
  const { mutate: removeInsurancePackage } = useRemoveInsurancePolicyPackage();

  const handleEditPackage = (pack: InsurancePolicyPackage) => {
    updateInsurancePackage({ insurancePackage: pack, partyId });
  };

  const handleRemovePackage = (packageId: string) => {
    removeInsurancePackage({ partyId, packageId });
  };

  return (
    <InsurancePolicyPackagesContainer
      packages={packages}
      customRiskObjects={customRiskObjects}
      partyType={partyType}
      partyId={partyId}
      controlled
      onAddPolicy={onEditPolicy}
      onEdit={handleEditPackage}
      onRemove={handleRemovePackage}
      onEditPolicy={onEditPolicy}
      onRemovePolicy={onRemovePolicy}
    />
  );
};

export default PartyInsurancePolicyPackagesContainer;
